<form class="w-[50vw] ml-[25vw] pt-[1vh]" [formGroup]="editCustomerForm">
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Customer.FirstName'|translate}${'FieldRequiredMarker'|translate}` }}</div>
  <input id="firstName" type="text" variant="filled" fluid="true" pInputText pSize="large"
         formControlName="firstName" [invalid]="isFormControlInvalid(editCustomerForm.controls.firstName, submitButtonClicked)"/>
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Customer.LastName'|translate}${'FieldRequiredMarker'|translate}` }}</div>
  <input id="lastName" type="text" variant="filled" fluid="true" pInputText pSize="large"
         formControlName="lastName" [invalid]="isFormControlInvalid(editCustomerForm.controls.lastName, submitButtonClicked)"/>
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'Customer.Company'|translate }}</div>
  <input id="company" type="text" variant="filled" fluid="true" pInputText pSize="large"
         formControlName="company" [invalid]="isFormControlInvalid(editCustomerForm.controls.company, submitButtonClicked)"/>
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Customer.EMail'|translate}(${'FieldRequiredMarker'|translate})` }}</div>
  <input id="eMail" type="text" variant="filled" fluid="true" pInputText pSize="large"
         formControlName="eMail" [invalid]="isFormControlInvalid(editCustomerForm.controls.eMail, submitButtonClicked)"/>
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Customer.PhoneNumber'|translate}(${'FieldRequiredMarker'|translate})` }}</div>
  <input id="phoneNumber" type="text" variant="filled" fluid="true" pInputText pSize="large"
         formControlName="phoneNumber" [invalid]="isFormControlInvalid(editCustomerForm.controls.phoneNumber, submitButtonClicked)"/>
  <div class="flex mt-[1vh]">
    <div class="w-[25vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start"> {{ `${'Customer.Street'|translate}` }}</div>
      <input id="street" type="text" variant="filled" fluid="true" pInputText pSize="large"
             formControlName="street" [invalid]="isFormControlInvalid(editCustomerForm.controls.street, submitButtonClicked)"/>
    </div>
    <div class="w-[25vw] ml-[1vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start"> {{ `${'Customer.HouseNumber'|translate}` }}</div>
      <input id="houseNumber" type="text" variant="filled" fluid="true" pInputText pSize="large"
             formControlName="houseNumber" [invalid]="isFormControlInvalid(editCustomerForm.controls.houseNumber, submitButtonClicked)"/>
    </div>
  </div>
  <div class="flex mt-[1vh]">
    <div class="w-[25vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start"> {{ `${'Customer.PostalCode'|translate}${'FieldRequiredMarker'|translate}` }}</div>
      <input id="postalCode" type="text" variant="filled" fluid="true" pInputText pSize="large"
             formControlName="postalCode" [invalid]="isFormControlInvalid(editCustomerForm.controls.postalCode, submitButtonClicked)"/>
    </div>
    <div class="w-[25vw] ml-[1vw]">
      <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start"> {{ `${'Customer.City'|translate}${'FieldRequiredMarker'|translate}` }}</div>
      <input id="city" type="text" variant="filled" fluid="true" pInputText pSize="large"
             formControlName="city" [invalid]="isFormControlInvalid(editCustomerForm.controls.city, submitButtonClicked)"/>
    </div>
  </div>
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Customer.Country'|translate}${'FieldRequiredMarker'|translate}`}}</div>
  <p-select id="country" [options]="countries" variant="filled" fluid="true" pSize="large"
            formControlName="country" [invalid]="isFormControlInvalid(editCustomerForm.controls.country, submitButtonClicked)"/>
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'Customer.Notes'|translate }}</div>
  <p-editor formControlName="notes" [style]="{ height: '10vh' }" [invalid]="isFormControlInvalid(editCustomerForm.controls.notes, submitButtonClicked)">
    <ng-template #header>
                <span class="ql-formats">
                  <button type="button" class="ql-bold" aria-label="Bold"></button>
                  <button type="button" class="ql-italic" aria-label="Italic"></button>
                  <button type="button" class="ql-underline" aria-label="Underline"></button>
                  <button type="button" class="ql-strike" aria-label="Strike"></button>
                  <span class="ql-formats">
                    <select class="ql-color" aria-label="Color">
                      <option selected></option>
                      <option value="red"></option>
                      <option value="blue"></option>
                      <option value="yellow"></option>
                      <option value="white"></option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <select class="ql-size" aria-label="Size">
                      <option selected></option>
                      <option value="small"></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                  </span>
                </span>
    </ng-template>
  </p-editor>
  <div class="flex justify-around mt-[3vh]">
    <p-button type="submit" size="large"
              label="{{'EditCustomers.Save'|translate}}" (onClick)="onSubmit()"/>
    <p-button type="submit" size="large"
              label="{{'EditCustomers.Abort'|translate}}" (onClick)="abortEdit()"/>
  </div>
</form>
